(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function initializeHeaderAnnouncements(root) {
    root.querySelectorAll('[data-header-announcements]').forEach((slider) => {
      if (slider.dataset.initialized) return;
      slider.dataset.initialized = 'true';
      const slides = Array.from(slider.querySelectorAll('[data-announcement-slide]'));
      let currentIndex = 0;

      function showSlide(index) {
        if (!slides.length) return;
        currentIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          slide.hidden = slideIndex !== currentIndex;
        });
      }

      slider.addEventListener('click', (event) => {
        if (event.target.closest('[data-announcement-next]')) showSlide(currentIndex + 1);
        if (event.target.closest('[data-announcement-previous]')) showSlide(currentIndex - 1);
      });
      slider.addEventListener('shopify:block:select', (event) => {
        const index = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (index !== -1) showSlide(index);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeHeaderAnnouncements(document));
  } else {
    initializeHeaderAnnouncements(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeHeaderAnnouncements(event.target));

  } catch(e) { console.error(e); }
})();
})();
